import React, { useState,useEffect } from 'react';
import { CheckCircle, AlertCircle, Mic, Info, Shield, Check, Mail, Phone } from 'lucide-react';

const VoiceRecordingConsentForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    agreed: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };
  useEffect(() => {
    // Hide Google Translate element when the component mounts
    const googleTranslateElement = document.getElementById("google_translate_element");
    if (googleTranslateElement) {
      googleTranslateElement.style.display = "none";
    }
    const trasnlateHindiButoon = document.querySelector(".translation-buttons");
    if (trasnlateHindiButoon) {
      trasnlateHindiButoon.style.display = "none";
    }


    // Show Google Translate element when the component unmounts
    return () => {
      if (googleTranslateElement) {
        googleTranslateElement.style.display = "block";
      }
      if (trasnlateHindiButoon) {
        trasnlateHindiButoon.style.display = "block";
      }
    };
  }, []);

  return (
    <div className="max-w-7xl mx-auto mt-10 p-8 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg shadow-xl">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div className="flex items-center justify-center">
            <div className="relative">
              <Mic className="w-20 h-20 text-blue-600 animate-pulse" />
              <div className="absolute top-0 left-0 w-full h-full border-4 border-blue-300 rounded-full animate-ping"></div>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-center text-gray-800">Voice Recording Consent</h2>
          <p className="text-center text-gray-600">We value your privacy and request your permission to record your voice for [purpose of recording].</p>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-bold text-lg mb-4 flex items-center"><Info className="w-5 h-5 mr-2 text-blue-500" /> Why We Need Your Consent</h3>
            <ul className="space-y-3">
              {[
                'To ensure transparency in our voice recording process',
                'To comply with data protection regulations',
                'To respect your privacy rights'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3">
                    <Check className="w-3 h-3 text-blue-600" />
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-bold text-lg mb-4 flex items-center"><Shield className="w-5 h-5 mr-2 text-green-500" /> How We Protect Your Data</h3>
            <ul className="space-y-3">
              {[
                'Secure storage of all recorded data',
                'Limited access to authorized personnel only',
                'Regular audits of our data protection measures'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-1 mr-3">
                    <Check className="w-3 h-3 text-green-600" />
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-lg shadow-md">
          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Full Name"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 pl-12"
              />
              <label htmlFor="name" className="absolute left-4 top-4 text-gray-400">
                <CheckCircle className="w-5 h-5" />
              </label>
            </div>
            <div className="relative">
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                placeholder="Phone Number"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 pl-12"
              />
              <label htmlFor="phoneNumber" className="absolute left-4 top-4 text-gray-400">
                <Phone className="w-5 h-5" />
              </label>
            </div>
          </div>
          <div className="flex items-start bg-blue-50 p-4 rounded-md">
            <div className="flex items-center h-5">
              <input
                type="checkbox"
                id="consent"
                name="agreed"
                checked={formData.agreed}
                onChange={handleChange}
                className="focus:ring-blue-500 h-5 w-5 text-blue-600 border-gray-300 rounded"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="consent" className="font-medium text-gray-700">I consent to voice recording</label>
              <p className="text-gray-500 mt-1">I understand and agree that my voice will be recorded. I have read and accept the terms of use and privacy policy.</p>
            </div>
          </div>
          <button
            type="submit"
            disabled={!formData.agreed}
            className={`w-full py-4 px-6 rounded-md shadow-md text-lg font-semibold text-white transition-all duration-300 ${
              formData.agreed ? 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transform hover:scale-105' : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            Give Consent
          </button>
        </form>
      </div>
      {submitted && (
        <div className={`mt-6 p-4 rounded-md ${formData.agreed ? 'bg-green-100' : 'bg-red-100'}`}>
          {formData.agreed ? (
            <div className="flex items-center text-green-800">
              <CheckCircle className="h-5 w-5 mr-2" />
              <span>Thank you, {formData.name}. Your consent for voice recording has been recorded.</span>
            </div>
          ) : (
            <div className="flex items-center text-red-800">
              <AlertCircle className="h-5 w-5 mr-2" />
              <span>Please agree to the voice recording consent before submitting.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VoiceRecordingConsentForm;